// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/gosanja/GosanjaOTF.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/quest/ox_greet_bubble.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/quest/ox_done_bg.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/quest/ox_done_char.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/quest/ox_done_title.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * OX 퀴즈 수행 흐름 — 화면 ① 인트로 · ② 인사말
 * 권위: docs/2026-08-12-ox-quiz-mission-flow-figma-redesign-dev-steps.md §"화면 사양"
 * Figma 3229:42024(①) · 3270:46529(②) — 둘 다 프레임 1920×1200, 2026-08-12 취득.
 *
 * 🔴 절대 px 을 쓰지 않고 \`--oxq-u\`(vw 환산)로 잡는다 — 이 화면들은 1280×800 과
 *    1920×1200 두 해상도를 함께 쓴다. 피그마 절대좌표를 그대로 옮기면 한쪽이 깨진다.
 *
 * 회귀 가드: OxQuizFlowScreens.test.jsx
 */

/* 🔴 Figma 지정 폰트. Katuri 로 대신 그리면 같은 크기라도 자폭이 약 16% 좁아
   글자 좌우 끝이 디자인과 다른 자리에 떨어진다(2026-08-05 실측).
   출처: 국토지리정보원 × 산돌 「고산자」 (상업이용·웹폰트 임베딩 허용). */
@font-face {
  font-family: 'GosanjaOTF';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('opentype');
  font-weight: 400;
  font-display: swap;
}

/* 세 화면 공통 무대 — 페이지를 통째로 덮는다.
   z-index 20 은 기존 \`.qt-first-mission-intro\` 와 같은 값이다. */
.oxq-screen {
  --oxq-scale: 1; /* 크기 조절 손잡이. 1 = Figma 원본 */
  --oxq-u: calc(100vw / 1920 * var(--oxq-scale)); /* Figma 1px */

  position: absolute;
  inset: 0;
  z-index: 20;
  overflow: hidden;
  font-family: 'GosanjaOTF', 'Katuri', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

/* 화면 ②·③ 공통 배경 — Figma: #fcebcf 가 47.799% 까지 유지된 뒤 #e2cfaa 로.
   \`from-[47.799%]\` 는 그라데이션 **시작 지점**이지 색 정지점 두 개가 아니다. */
.oxq-screen-beige {
  background: linear-gradient(180deg, #fcebcf 47.799%, #e2cfaa 100%);
}

/* ══════════════ 화면 ① 공통 인트로 ══════════════
   CRM 영상 자체가 완성 화면이므로 별도 번들 배경이나 오버레이를 합성하지 않는다. */
.oxq-intro {
  background: #000;
}

.oxq-intro-stage {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* CRM에 등록한 완성 영상을 화면 전체에 표시한다. 태블릿 비율 차이는 cover로 채운다. */
.oxq-intro-video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border: 0;
  background: transparent;
  /* Android WebView 의 autoplay 시작 전 네이티브 플레이 아이콘까지 함께 숨긴다. */
  opacity: 0;
  transition: opacity 120ms linear;
}

.oxq-intro-video-playing {
  opacity: 1;
}

/* ══════════════ 화면 ② 인사말 (Figma 3270:46529) ══════════════
   🔴 **인사말 영상의 크기·위치에 디자인 근거가 없다**(잔류 리스크 L1).
      노드의 자식은 말풍선 + 텍스트 2개뿐이고 "왼쪽 고양이" 는 없다(실측).
      사용자 확정(R7): 말풍선 왼쪽 빈 영역(x 0~782)을 비율 유지로 꽉 채운다. */
.oxq-greet-video {
  position: absolute;
  left: 0;
  top: 0;
  width: calc(782 * var(--oxq-u));
  height: 100%;
  object-fit: contain;
  border: 0;
  background: transparent;
  /* 🔴 재생 시작 전 감춤 (2026-08-18) — \`.oxq-verdict-video\` 와 같은 사유·같은 처방.
     이 자리는 비어 있어도 말풍선·별명이 그대로 보이므로 빈 화면이 되지 않는다. */
  opacity: 0;
  transition: opacity 120ms linear;
}

.oxq-greet-video-playing {
  opacity: 1;
}

/* 말풍선 — Figma x782 y70, 1078×1090 */
.oxq-greet-bubble {
  position: absolute;
  left: calc(782 * var(--oxq-u));
  top: calc(70 * var(--oxq-u));
  width: calc(1078 * var(--oxq-u));
  height: calc(1090 * var(--oxq-u));
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center / contain;
  pointer-events: none;
}

/* 별명 — Figma x1001 y176, 686×312, 120px #ff5816 중앙정렬 */
.oxq-greet-name {
  position: absolute;
  left: calc(1001 * var(--oxq-u));
  top: calc(176 * var(--oxq-u));
  width: calc(686 * var(--oxq-u));
  margin: 0;
  font-size: calc(120 * var(--oxq-u));
  line-height: 1.3;
  color: #ff5816;
  text-align: center;
  word-break: break-word;
  /* 🔴 **2줄로 자른다.** 디자인 상자 높이 312 = 120×1.3×2 다. 긴 별명이 3줄이 되면
     아래 본문(top 510)을 침범해 두 문장이 겹쳐 읽힌다(잔류 리스크 L7 — 긴 별명 분포 미조사). */
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* 본문 3줄 고정 — Figma x1001 y510, 686×468, 120px #189018 */
.oxq-greet-lines {
  position: absolute;
  left: calc(1001 * var(--oxq-u));
  top: calc(510 * var(--oxq-u));
  width: calc(686 * var(--oxq-u));
  margin: 0;
  font-size: calc(120 * var(--oxq-u));
  line-height: 1.3;
  color: #189018;
  text-align: center;
}

.oxq-greet-lines p {
  margin: 0;
}

/* ══════════════ 정답/오답 영상 오버레이 (Figma 3481:47885, 2026-08-13) ══════════════
   사용자 요구: "퀴즈화면 위에 오버레이 해서 영상을 보여주고(반투명 레이어로)".

   🔴 **아래 문제 화면이 비쳐야 한다.** 불투명하게 덮으면 오버레이가 아니라 화면 전환이다.
      알파 1 을 막는 CSS 가드가 걸려 있다(OxQuizVerdict.test.jsx).
   🔴 \`z-index\` 는 문제 화면 요소(체크 표식 5)보다 위여야 한다. 30 으로 둔다 —
      \`.oxq-screen\`(20)보다 위, 관리자 바보다 아래. */
.oxq-verdict-overlay {
  /* 🔴 **스케일 변수를 여기서 직접 정의한다.** 이 오버레이는 \`.oxq-screen\` 이 아니라
     \`.ox-quiz\`(문제 화면) **안에** 렌더된다 — 그 조상에는 \`--quiz-u\` 만 있고 \`--oxq-u\` 는
     없다. 상속에 기대면 \`calc(1024 * var(--oxq-u))\` 가 무효가 되어 영상이 브라우저
     기본 크기(300×150)로 쪼그라든다(2026-08-13 실측으로 발견 — CSS 원문 가드는
     선언이 존재하므로 통과했고 **브라우저 실측만이 잡았다**). */
  --oxq-scale: 1;
  --oxq-u: calc(100vw / 1920 * var(--oxq-scale));

  position: absolute;
  inset: 0;
  z-index: 30;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.6);
  backdrop-filter: blur(25px);
  -webkit-backdrop-filter: blur(25px); /* Android WebView 구버전 대응 */
}

/* 영상 — Figma 콘텐츠 상자 (448,88) 1024×1024 → 중심 (960,600) = 화면 정중앙.
   flex 중앙정렬이라 좌표를 따로 주지 않아도 같은 자리에 온다.
   🔴 \`contain\` 은 **내 판단**이다(디자인은 정사각 스틸이라 fit 근거가 없다 — L9).
      관리자가 올리는 영상은 16:9 가 흔한데 cover/fill 이면 잘리거나 찌그러진다. */
.oxq-verdict-video {
  width: calc(1024 * var(--oxq-u));
  height: calc(1024 * var(--oxq-u));
  object-fit: contain;
  border: 0;
  background: transparent;
  /* 🔴 재생이 실제로 시작되기 전에는 감춘다 (2026-08-18) — Android WebView 가 autoplay
     직전에 네이티브 재생 오버레이/빈 판을 잠깐 그린다. 의사요소 억제(index.css)와 **짝**이며,
     여기서는 그 사이 아래 문제 화면이 흐릿하게 비치기만 한다(빈 검은 판보다 자연스럽다).
     \`.oxq-intro-video\` 와 같은 처방이다 — 둘 중 하나만 고치면 화면마다 동작이 갈린다. */
  opacity: 0;
  transition: opacity 120ms linear;
}

.oxq-verdict-video-playing {
  opacity: 1;
}

/* ══════════════ 마무리 화면 (Figma 3601:43294 · 3601:45510) ══════════════
   🔴 2026-08-14: 사진찍기도 이 화면으로 합류했다(두 노드의 자산·좌표가 동일).
      OX 전용이 아니므로 값을 고칠 때 사진찍기 마무리도 함께 바뀐다.

   🔴 세 그림 모두 \`object-fit\` 을 주지 않는다 — 피그마가 \`size-full\` 만 지정해
      기본값 fill(늘림)로 렌더되기 때문이다. 배경 크기를 100% 100% 로 두는 것이
      그 동작과 같다. 임의로 contain/cover 를 쓰면 디자인과 다른 화면이 된다. */
.oxq-done-bg {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat center / 100% 100%;
}

/* 좌측 캐릭터 — Figma (52,60) 797×1120 */
.oxq-done-char {
  position: absolute;
  left: calc(52 * var(--oxq-u));
  top: calc(60 * var(--oxq-u));
  width: calc(797 * var(--oxq-u));
  height: calc(1120 * var(--oxq-u));
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat center / 100% 100%;
}

/* 우측 타이틀 "미션 대성공!" — Figma (797,216) 1024×706 */
.oxq-done-title {
  position: absolute;
  left: calc(797 * var(--oxq-u));
  top: calc(216 * var(--oxq-u));
  width: calc(1024 * var(--oxq-u));
  height: calc(706 * var(--oxq-u));
  background: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) no-repeat center / 100% 100%;
}
`, "",{"version":3,"sources":["webpack://./src/components/quest/OxQuizFlow.css"],"names":[],"mappings":"AAAA;;;;;;;;;EASE;;AAEF;;8CAE8C;AAC9C;EACE,yBAAyB;EACzB,+DAAwE;EACxE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;wDACwD;AACxD;EACE,cAAc,EAAE,4BAA4B;EAC5C,8CAA8C,EAAE,cAAc;;EAE9D,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,8FAA8F;AAChG;;AAEA;yDACyD;AACzD;EACE,kEAAkE;AACpE;;AAEA;mDACmD;AACnD;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,wDAAwD;AACxD;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,SAAS;EACT,uBAAuB;EACvB,2DAA2D;EAC3D,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,UAAU;AACZ;;AAEA;;;uDAGuD;AACvD;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,+BAA+B;EAC/B,YAAY;EACZ,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB;kDACgD;EAChD,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,UAAU;AACZ;;AAEA,oCAAoC;AACpC;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,4BAA4B;EAC5B,gCAAgC;EAChC,iCAAiC;EACjC,8EAAqF;EACrF,oBAAoB;AACtB;;AAEA,uDAAuD;AACvD;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,6BAA6B;EAC7B,+BAA+B;EAC/B,SAAS;EACT,mCAAmC;EACnC,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB;iEAC+D;EAC/D,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,wDAAwD;AACxD;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,6BAA6B;EAC7B,+BAA+B;EAC/B,SAAS;EACT,mCAAmC;EACnC,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;;;;;;0CAM0C;AAC1C;EACE;;;;yCAIuC;EACvC,cAAc;EACd,8CAA8C;;EAE9C,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,oCAAoC;EACpC,2BAA2B;EAC3B,mCAAmC,EAAE,2BAA2B;AAClE;;AAEA;;;yDAGyD;AACzD;EACE,gCAAgC;EAChC,iCAAiC;EACjC,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB;;;+DAG6D;EAC7D,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,UAAU;AACZ;;AAEA;;;;;;wDAMwD;AACxD;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,gFAAkF;AACpF;;AAEA,oCAAoC;AACpC;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,4BAA4B;EAC5B,+BAA+B;EAC/B,iCAAiC;EACjC,gFAAoF;AACtF;;AAEA,gDAAgD;AAChD;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,6BAA6B;EAC7B,gCAAgC;EAChC,gCAAgC;EAChC,gFAAqF;AACvF","sourcesContent":["/**\n * OX 퀴즈 수행 흐름 — 화면 ① 인트로 · ② 인사말\n * 권위: docs/2026-08-12-ox-quiz-mission-flow-figma-redesign-dev-steps.md §\"화면 사양\"\n * Figma 3229:42024(①) · 3270:46529(②) — 둘 다 프레임 1920×1200, 2026-08-12 취득.\n *\n * 🔴 절대 px 을 쓰지 않고 `--oxq-u`(vw 환산)로 잡는다 — 이 화면들은 1280×800 과\n *    1920×1200 두 해상도를 함께 쓴다. 피그마 절대좌표를 그대로 옮기면 한쪽이 깨진다.\n *\n * 회귀 가드: OxQuizFlowScreens.test.jsx\n */\n\n/* 🔴 Figma 지정 폰트. Katuri 로 대신 그리면 같은 크기라도 자폭이 약 16% 좁아\n   글자 좌우 끝이 디자인과 다른 자리에 떨어진다(2026-08-05 실측).\n   출처: 국토지리정보원 × 산돌 「고산자」 (상업이용·웹폰트 임베딩 허용). */\n@font-face {\n  font-family: 'GosanjaOTF';\n  src: url('../../assets/fonts/gosanja/GosanjaOTF.otf') format('opentype');\n  font-weight: 400;\n  font-display: swap;\n}\n\n/* 세 화면 공통 무대 — 페이지를 통째로 덮는다.\n   z-index 20 은 기존 `.qt-first-mission-intro` 와 같은 값이다. */\n.oxq-screen {\n  --oxq-scale: 1; /* 크기 조절 손잡이. 1 = Figma 원본 */\n  --oxq-u: calc(100vw / 1920 * var(--oxq-scale)); /* Figma 1px */\n\n  position: absolute;\n  inset: 0;\n  z-index: 20;\n  overflow: hidden;\n  font-family: 'GosanjaOTF', 'Katuri', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n}\n\n/* 화면 ②·③ 공통 배경 — Figma: #fcebcf 가 47.799% 까지 유지된 뒤 #e2cfaa 로.\n   `from-[47.799%]` 는 그라데이션 **시작 지점**이지 색 정지점 두 개가 아니다. */\n.oxq-screen-beige {\n  background: linear-gradient(180deg, #fcebcf 47.799%, #e2cfaa 100%);\n}\n\n/* ══════════════ 화면 ① 공통 인트로 ══════════════\n   CRM 영상 자체가 완성 화면이므로 별도 번들 배경이나 오버레이를 합성하지 않는다. */\n.oxq-intro {\n  background: #000;\n}\n\n.oxq-intro-stage {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* CRM에 등록한 완성 영상을 화면 전체에 표시한다. 태블릿 비율 차이는 cover로 채운다. */\n.oxq-intro-video {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border: 0;\n  background: transparent;\n  /* Android WebView 의 autoplay 시작 전 네이티브 플레이 아이콘까지 함께 숨긴다. */\n  opacity: 0;\n  transition: opacity 120ms linear;\n}\n\n.oxq-intro-video-playing {\n  opacity: 1;\n}\n\n/* ══════════════ 화면 ② 인사말 (Figma 3270:46529) ══════════════\n   🔴 **인사말 영상의 크기·위치에 디자인 근거가 없다**(잔류 리스크 L1).\n      노드의 자식은 말풍선 + 텍스트 2개뿐이고 \"왼쪽 고양이\" 는 없다(실측).\n      사용자 확정(R7): 말풍선 왼쪽 빈 영역(x 0~782)을 비율 유지로 꽉 채운다. */\n.oxq-greet-video {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: calc(782 * var(--oxq-u));\n  height: 100%;\n  object-fit: contain;\n  border: 0;\n  background: transparent;\n  /* 🔴 재생 시작 전 감춤 (2026-08-18) — `.oxq-verdict-video` 와 같은 사유·같은 처방.\n     이 자리는 비어 있어도 말풍선·별명이 그대로 보이므로 빈 화면이 되지 않는다. */\n  opacity: 0;\n  transition: opacity 120ms linear;\n}\n\n.oxq-greet-video-playing {\n  opacity: 1;\n}\n\n/* 말풍선 — Figma x782 y70, 1078×1090 */\n.oxq-greet-bubble {\n  position: absolute;\n  left: calc(782 * var(--oxq-u));\n  top: calc(70 * var(--oxq-u));\n  width: calc(1078 * var(--oxq-u));\n  height: calc(1090 * var(--oxq-u));\n  background: url('../../assets/quest/ox_greet_bubble.webp') no-repeat center / contain;\n  pointer-events: none;\n}\n\n/* 별명 — Figma x1001 y176, 686×312, 120px #ff5816 중앙정렬 */\n.oxq-greet-name {\n  position: absolute;\n  left: calc(1001 * var(--oxq-u));\n  top: calc(176 * var(--oxq-u));\n  width: calc(686 * var(--oxq-u));\n  margin: 0;\n  font-size: calc(120 * var(--oxq-u));\n  line-height: 1.3;\n  color: #ff5816;\n  text-align: center;\n  word-break: break-word;\n  /* 🔴 **2줄로 자른다.** 디자인 상자 높이 312 = 120×1.3×2 다. 긴 별명이 3줄이 되면\n     아래 본문(top 510)을 침범해 두 문장이 겹쳐 읽힌다(잔류 리스크 L7 — 긴 별명 분포 미조사). */\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n/* 본문 3줄 고정 — Figma x1001 y510, 686×468, 120px #189018 */\n.oxq-greet-lines {\n  position: absolute;\n  left: calc(1001 * var(--oxq-u));\n  top: calc(510 * var(--oxq-u));\n  width: calc(686 * var(--oxq-u));\n  margin: 0;\n  font-size: calc(120 * var(--oxq-u));\n  line-height: 1.3;\n  color: #189018;\n  text-align: center;\n}\n\n.oxq-greet-lines p {\n  margin: 0;\n}\n\n/* ══════════════ 정답/오답 영상 오버레이 (Figma 3481:47885, 2026-08-13) ══════════════\n   사용자 요구: \"퀴즈화면 위에 오버레이 해서 영상을 보여주고(반투명 레이어로)\".\n\n   🔴 **아래 문제 화면이 비쳐야 한다.** 불투명하게 덮으면 오버레이가 아니라 화면 전환이다.\n      알파 1 을 막는 CSS 가드가 걸려 있다(OxQuizVerdict.test.jsx).\n   🔴 `z-index` 는 문제 화면 요소(체크 표식 5)보다 위여야 한다. 30 으로 둔다 —\n      `.oxq-screen`(20)보다 위, 관리자 바보다 아래. */\n.oxq-verdict-overlay {\n  /* 🔴 **스케일 변수를 여기서 직접 정의한다.** 이 오버레이는 `.oxq-screen` 이 아니라\n     `.ox-quiz`(문제 화면) **안에** 렌더된다 — 그 조상에는 `--quiz-u` 만 있고 `--oxq-u` 는\n     없다. 상속에 기대면 `calc(1024 * var(--oxq-u))` 가 무효가 되어 영상이 브라우저\n     기본 크기(300×150)로 쪼그라든다(2026-08-13 실측으로 발견 — CSS 원문 가드는\n     선언이 존재하므로 통과했고 **브라우저 실측만이 잡았다**). */\n  --oxq-scale: 1;\n  --oxq-u: calc(100vw / 1920 * var(--oxq-scale));\n\n  position: absolute;\n  inset: 0;\n  z-index: 30;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  background: rgba(255, 255, 255, 0.6);\n  backdrop-filter: blur(25px);\n  -webkit-backdrop-filter: blur(25px); /* Android WebView 구버전 대응 */\n}\n\n/* 영상 — Figma 콘텐츠 상자 (448,88) 1024×1024 → 중심 (960,600) = 화면 정중앙.\n   flex 중앙정렬이라 좌표를 따로 주지 않아도 같은 자리에 온다.\n   🔴 `contain` 은 **내 판단**이다(디자인은 정사각 스틸이라 fit 근거가 없다 — L9).\n      관리자가 올리는 영상은 16:9 가 흔한데 cover/fill 이면 잘리거나 찌그러진다. */\n.oxq-verdict-video {\n  width: calc(1024 * var(--oxq-u));\n  height: calc(1024 * var(--oxq-u));\n  object-fit: contain;\n  border: 0;\n  background: transparent;\n  /* 🔴 재생이 실제로 시작되기 전에는 감춘다 (2026-08-18) — Android WebView 가 autoplay\n     직전에 네이티브 재생 오버레이/빈 판을 잠깐 그린다. 의사요소 억제(index.css)와 **짝**이며,\n     여기서는 그 사이 아래 문제 화면이 흐릿하게 비치기만 한다(빈 검은 판보다 자연스럽다).\n     `.oxq-intro-video` 와 같은 처방이다 — 둘 중 하나만 고치면 화면마다 동작이 갈린다. */\n  opacity: 0;\n  transition: opacity 120ms linear;\n}\n\n.oxq-verdict-video-playing {\n  opacity: 1;\n}\n\n/* ══════════════ 마무리 화면 (Figma 3601:43294 · 3601:45510) ══════════════\n   🔴 2026-08-14: 사진찍기도 이 화면으로 합류했다(두 노드의 자산·좌표가 동일).\n      OX 전용이 아니므로 값을 고칠 때 사진찍기 마무리도 함께 바뀐다.\n\n   🔴 세 그림 모두 `object-fit` 을 주지 않는다 — 피그마가 `size-full` 만 지정해\n      기본값 fill(늘림)로 렌더되기 때문이다. 배경 크기를 100% 100% 로 두는 것이\n      그 동작과 같다. 임의로 contain/cover 를 쓰면 디자인과 다른 화면이 된다. */\n.oxq-done-bg {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  background: url('../../assets/quest/ox_done_bg.webp') no-repeat center / 100% 100%;\n}\n\n/* 좌측 캐릭터 — Figma (52,60) 797×1120 */\n.oxq-done-char {\n  position: absolute;\n  left: calc(52 * var(--oxq-u));\n  top: calc(60 * var(--oxq-u));\n  width: calc(797 * var(--oxq-u));\n  height: calc(1120 * var(--oxq-u));\n  background: url('../../assets/quest/ox_done_char.webp') no-repeat center / 100% 100%;\n}\n\n/* 우측 타이틀 \"미션 대성공!\" — Figma (797,216) 1024×706 */\n.oxq-done-title {\n  position: absolute;\n  left: calc(797 * var(--oxq-u));\n  top: calc(216 * var(--oxq-u));\n  width: calc(1024 * var(--oxq-u));\n  height: calc(706 * var(--oxq-u));\n  background: url('../../assets/quest/ox_done_title.webp') no-repeat center / 100% 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
